import React, { useContext, useEffect, useState } from 'react';
import CallTableViewModel from '../../../ViewModels/CallTableViewModel';
import { APIContext } from '../../../Contexts/APIContext';
import SalesAIAnswerViewModel from './ViewModels/SalesAIAnswerViewModel';
import { useSnackbar } from 'notistack';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface IFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function SalesAIDialog(props: IFiltersDialogProps) {
    const { get } = useContext(APIContext);
    const [templateOptions, setTemplateOptions] = useState<string[]>([]);
    const [questionOptions, setQuestionOptions] = useState<string[]>([]);
    const [categoryOptions, setCategoryOptions] = useState<string[]>([]);
    const [salesAIFilter, setSalesAIFilter] = useState<SalesAIAnswerViewModel>(props.callTableViewModel.filters.salesAI);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (props.open) {
            setSalesAIFilter(props.callTableViewModel.filters.salesAI);
        }
    }, [props.open])

    useEffect(() => {
        getTemplateOptions();
    }, []);


    useEffect(() => {
        ClearOptions();
        if (salesAIFilter.channel !== '') getCategoryOptions();
    }, [salesAIFilter.channel]);

    useEffect(() => {
        if (salesAIFilter.channel !== '' && salesAIFilter.category !== '') getQuestionOptions();
    }, [salesAIFilter.category]);

    //#region database calls
    const getTemplateOptions = () => {
        get('AIAnalysis', `GetSalesAITemplateOptions?client=` + props.callTableViewModel.filters.client, (data) => {
            setTemplateOptions(data);
        });
    }
    const getCategoryOptions = () => {
        get('AIAnalysis', `GetSalesAICategoryOptions?client=` + props.callTableViewModel.filters.client + `&channel=` + salesAIFilter.channel, (data) => {
            setCategoryOptions(data)
        });
    }
    const getQuestionOptions = () => {
        get('AIAnalysis', `GetSalesAIQuestionOptions?client=` + props.callTableViewModel.filters.client + `&channel=` + salesAIFilter.channel + '&category=' + salesAIFilter.category, (data) => {
            setQuestionOptions(data)
        });
    }
    //#endregion

    const ClearOptions = () => {
        setSalesAIFilter({
            ...salesAIFilter,
            question: "",
            category: "",
            answer: ""
        });
    }
    const HandleSelect = (key: string, value: string) => {
        setSalesAIFilter({
            ...salesAIFilter,
            [key]: value
        });
    }
    const HandleSelectCategory = (key: string, value: string) => {
        setSalesAIFilter({
            ...salesAIFilter,
            category: value
        });
    }
    const HandleSelectAnswer = (key: string, value: string) => {
        setSalesAIFilter({
            ...salesAIFilter,
            answer: value
        });
    }

    const Confirm = () => {
        if (salesAIFilter.channel !== '' && salesAIFilter.question !== '') {
            const newCallTableViewModel = { ...props.callTableViewModel };

            newCallTableViewModel.filters.salesAI = salesAIFilter;

            props.setCallTableViewModel({
                ...newCallTableViewModel
            })
            props.setOpen(false);
        } else {
            enqueueSnackbar("All values must be selected to confirm", { variant: 'warning' });
        }
    }

    return (
        <Dialog onClose={() => props.setOpen(false)} open={props.open} fullWidth maxWidth="sm">
            <DialogTitle>Sales-AI</DialogTitle>
            <DialogContent>
                {templateOptions.length > 0 ?
                    <Grid container style={{ width: '100%' }}>
                        <Grid size={12}>
                            <InputLabel>Channel</InputLabel>
                            <TextField
                                select
                                name="channel"
                                value={salesAIFilter.channel}
                                onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                fullWidth
                            >
                                {templateOptions.map((template: string) => {
                                    return (<MenuItem key={template} value={template}>{template}</MenuItem>);
                                })}
                            </TextField>
                        </Grid>
                        {salesAIFilter.channel !== '' &&
                            <Grid size={12}>
                                <InputLabel>Category</InputLabel>
                                <TextField
                                    select
                                    name="category"
                                    value={salesAIFilter.category}
                                    onChange={(e) => HandleSelectCategory(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={salesAIFilter.channel === ''}
                                >
                                    {categoryOptions.length > 0 && categoryOptions.map((category: string) => {
                                        return (<MenuItem key={category} value={category}>{category}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        }
                        {salesAIFilter.channel !== '' && salesAIFilter.category !== '' &&
                            <Grid size={12}>
                                <InputLabel>Question</InputLabel>
                                <TextField
                                    select
                                    name="question"
                                    value={salesAIFilter.question}
                                    onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={salesAIFilter.channel === '' || salesAIFilter.category === ''}
                                >
                                    {questionOptions.length > 0 && questionOptions.map((question: string) => {
                                        return (<MenuItem key={question} value={question}>{question}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        }
                        {salesAIFilter.channel !== '' && salesAIFilter.question !== '' &&
                            <Grid size={12}>
                                <InputLabel>Answer</InputLabel>
                                <TextField
                                    select
                                    name="answer"
                                    value={salesAIFilter.answer}
                                    onChange={(e) => HandleSelectAnswer(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={salesAIFilter.channel === '' || salesAIFilter.question === ''}
                                >
                                    <MenuItem key={0} value="Yes">Yes</MenuItem>
                                    <MenuItem key={1} value="No">No</MenuItem>
                                    <MenuItem key={2} value="N/A">N/A</MenuItem>
                                </TextField>
                            </Grid>
                        }
                    </Grid>
                    :
                    <p>This AI Filter Is Not Used By This Client</p>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)} color="primary">Cancel</Button>
                {templateOptions.length > 0 &&
                    <Button onClick={Confirm} color="primary">Confirm</Button>
                }
            </DialogActions>
        </Dialog>
    )
}